export default {
  title: 'CheatSheets für Alle!',
  description: `${''}Hier findest Du eine Sammlung meiner CheatSheets, die sich im Laufe der Zeit angesammelt haben. Sie werden auf GitHub gewartet und können dort auch mittels Pull-Request abgeändert oder ausgebessert werden.`,
  sheets: {
    docker: {
      title: `${''}Docker`,
      description: `${''}Docker Befehle und Anleitungen.`
    },
    gpg: {
      title: `${''}GPG`,
      description: `${''}Generelle Kommandos.`
    },
    hibernation: {
      title: `${''}Scheduled Hibernation`,
      description: `${''}Einen Linux-Rechner zeitgesteuert schlafen legen und auch wieder aufwecken.`
    },
    keycloak: {
      title: `${''}Keycloak Upgrade von v-pre13`,
      description: `${''}Einen Keycloak-Server upgraden von einer sehr alten Version aus (pre 13).`
    },
    letsEncrypt: {
      title: `${''}Let's Encrypt`,
      description: `${''}Schritt-für-Schritt Anleitung für Linux und Nginx.`
    },
    linux: {
      title: `${''}Linux`,
      description: `${''}Übliche Linux-Kommandos um einen Rechner aufzusetzen oder zu warten, Docker Installation, Laufwerke und Partitionierung, Festplatten mounten, Samba, NFS...`
    },
    ssh: {
      title: `${''}SSH`,
      description: `${''}SSH mit RSA-Schlüsseln auf Client und Server einrichten, Schlüssel generieren, rsync.`
    },
    ssl: {
      title: `${''}SSL`,
      description: `${''}Operationen am Keystore, Key-Konvertierungen.`
    },
    vnc: {
      title: `${''}VNC`,
      description: `${''}RDP Protokolle, Server und Clients und Installationsanweisungen.`
    }
  }
}
